/**
 * Sets up key dependencies needed by the viewer. This only needs to be called on the entry point of your custom viewer bundle
 *
 * @export
 */
export function bootstrap() {
    
}